import Grid from '@mui/material/Grid';
import classNames from 'classnames';
import { useNavigate } from 'react-router';
import { _ } from '/@/locale';
import type { LibraryItem } from '/@/types/library';
import { formatDate } from '/@/utils';
import { reverse } from '/@/utils/router';
import styles from './styles.module.css';

const LibraryCard = ({ item, className }: { item: LibraryItem; className?: string }) => {
    const { name, updated, description } = item;
    const classNameCard = classNames(className, styles.card);

    const navigate = useNavigate();

    return (
        <div
            className={classNameCard}
            onClick={() => navigate(reverse('library.LibraryDetail', { params: { slug: item.slug } }))}
        >
            <Grid
                container
                sx={{
                    p: 2,
                    borderRadius: 1,
                    height: '100%',
                }}
            >
                <Grid item xs={12}>
                    <div className={styles.header}>
                        <i className='material-icons'>description</i>
                        <div className={styles.date}>{formatDate(new Date(updated))}</div>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className={styles.itemName}>
                        <div className={classNames(styles.name, styles[`theme-${item.categories?.[0].name.es}`])}>
                            {_(name)}
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className={styles.description}>{_(description)}</div>
                </Grid>
            </Grid>
        </div>
    );
};

export default LibraryCard;
